<template>
  <Tooltip
    v-if="isTruncated"
    :delay="300"
    :side="side"
    :title="title"
    disableHoverableContent
    ignorenonkeyboardfocus
  >
    <div
      ref="element"
      class="text-left w-full"
      :class="{
        [`line-clamp-${lines} whitespace-normal break-words`]: lines > 1,
        truncate: lines === 1,
      }"
    >
      {{ title }}
    </div>
  </Tooltip>
  <div
    v-else
    ref="element"
    class="text-left w-full"
    :class="{
      [`line-clamp-${lines} whitespace-normal break-words`]: lines > 1,
      truncate: lines === 1,
    }"
  >
    {{ title }}
  </div>
</template>

<script setup>
// Vue utilities
import { onMounted, ref, watch } from "vue";

// Utils
import { isTruncating } from "@/Utils/truncate";
import { debounce } from "lodash";

// Components
import { Tooltip } from "@/SharedComponents/Tooltips";

// Refs
const element = ref(null);
const isTruncated = ref(false);

// Define Props
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  listeners: {
    type: Array,
    default: () => [],
  },
  lines: {
    type: Number,
    default: 1,
  },
  side: {
    type: String,
    default: "right",
  },
});

// Functions
const handleTruncation = () => {
  if (element.value) {
    isTruncated.value = isTruncating(element.value, props.lines);
  }
};

const debounceHandleTruncation = debounce(() => {
  handleTruncation();
}, 100);

// Lifecycle Hooks
onMounted(() => {
  handleTruncation();
});

// Watcher
watch(
  () => props.listeners,
  () => {
    debounceHandleTruncation();
  },
  { deep: true }
);
</script>
